import {type FunctionalComponent, h} from '@stencil/core';
import {viewType} from '../../../../../constants/viewTypeConstants';
import type {labelProviderInterface} from '../../../../LabelProviderInterface';


export interface GridSwitchButton {
  gridViewSwitch: boolean
  switchGridView: CallableFunction
  gridView: boolean
  accessibilityMode: boolean
  labelProvider: labelProviderInterface
}

export const GridSwitchButton: FunctionalComponent<GridSwitchButton> = (props) => {

    const {gridViewSwitch, switchGridView, gridView, labelProvider} = props;

    return (gridViewSwitch ?
      <qds-segmented class="grid-list-switch" label="grid-list switch button">
        <qds-segmented-item
          icon-library="default"
          icon-name="dots-9-grid"
          text={labelProvider(
            'GRIDVIEW',
            'Grid'
          )}
          selected={gridView}
          size="small"
          onClick={() => switchGridView(viewType.GRID)}
        >
        </qds-segmented-item>
        <qds-segmented-item
          icon-library="default"
          icon-name="list-bullets"
          text={labelProvider(
            'LISTVIEW',
            'List'
          )}
          size="small"
          selected={!gridView}
          onClick={() => switchGridView(viewType.LIST)}
        ></qds-segmented-item>
      </qds-segmented> : '');




};
